import { useState } from "react";
import { backend_client } from "helpers/api";

export const useChangeValidationStatus = (questionId) => {
  const [isLoading, setIsLoading] = useState(false);

  const changeValidationStatus = async (newValidationStatus) => {
    setIsLoading(true);
    try {
      const response = await backend_client.patch(
        `/questions/${questionId}/change-validation-status?new_validation_status=${newValidationStatus}`
      );
      return response.data;
    } catch (error) {
      console.error("Error changing validation status:", error);
      throw error;
    } finally {
      setIsLoading(false);
    }
  };

  return {
    changeValidationStatus,
    isLoading,
  };
};
